import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from '@core/services/analytics.service';
import { Ga4Service } from '@core/services/ga4.service';
import { select, Store } from '@ngrx/store';
import { toggleMap } from '@results/store/results.actions';
// import { ToggleMap } from '@results/store/results.actions';
import { selectHotels } from '@results/store/results.selector';
import { IHotelsAppState } from '@store/index';
import { Observable, Subject } from 'rxjs';
import { MbButton, MbIcon } from '@am/moebius';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'am-view-map',
  standalone: true,
  styleUrls: ['./view-map.component.scss'],
  templateUrl: './view-map.component.html',
  imports: [MbButton, MbIcon, AsyncPipe],
})
export class ViewMapComponent implements OnInit, OnDestroy {
  @Input() public imageStyle = false;
  @Input() isMobile = false;
  @Input() isMap = false;
  public disabled: boolean;
  public hotels$: Observable<any>;
  private unSubscribe$ = new Subject<void>();

  constructor(
    private store$: Store<IHotelsAppState>,
    private analyticsService: AnalyticsService,
    private ga4Service?: Ga4Service,
  ) {}

  public ngOnInit(): void {
    this.hotels$ = this.store$.pipe(select(selectHotels));
  }

  public map(imageStyle: boolean) {
    this.trackViewMap(imageStyle);
    this.store$.dispatch(toggleMap({ payload: { viewMap: false, imageStyle } }));
  }

  private trackViewMap(imageStyle: boolean) {
    this.analyticsService.trackEvent({
      action: imageStyle ? 'View Map' : 'View Map Button',
      label: 'Show',
      section: 'Results',
    });
    if (this.ga4Service) {
      this.ga4Service.user_interaction({
        type: 'button',
        label: imageStyle ? 'ver alojamiento en mapa' : 'ver mapa',
        action: 'click',
        section: 'PLP',
      });
    }
  }
  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.unsubscribe();
  }
}
